"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @since 2019-12-27 01:24
 * @author vivaxy
 */
exports.default = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];
